var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3999 7.5H24.5999C26.2567 7.5 27.5999 8.84315 27.5999 10.5V20.3C27.5999 21.9569 26.2567 23.3 24.5999 23.3H15.8999L10.7999 28.1V23.3H9.3999C7.74305 23.3 6.3999 21.9569 6.3999 20.3V10.5C6.3999 8.84315 7.74305 7.5 9.3999 7.5Z",
    stroke: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2002 12.9H22.8002",
    stroke: "#E2E8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2002 17.3H19.0002",
    stroke: "#E2E8F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/Ask.b8198244.svg";
export { ForwardRef as ReactComponent };